import gql from 'graphql-tag';

const WearableConnectionsQuery = gql`
  query WearableConnections {
    wearable {
      connections {
        provider {
          openWearablesProvider
          displayName
          iconUrl
          availability
          displayOrder
        }
        status
        lastSyncedAt
        connectedAt
      }
    }
  }
`;

export default WearableConnectionsQuery;
